import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getChannelsFeedQuery,
  getOrganizationCoursesQuery,
  getUserFeedListQuery,
  getChatUsersQuery,
  getMessageV2UserDetailQuery,
  getConfigurationQuery,
  getChildrenYearGroupGradeQuery,
} from "MessagingV2/components/Settings/modules/SettingQueries";

export const getUserFeedListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getUserFeedListQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getChannelsFeedFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getChannelsFeedQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationCoursesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCoursesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getChatUsersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getChatUsersQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getMessageV2UserDetailFromCache = messageV2UserDetailVariables => {
  try {
    const queryData = client.readQuery({
      query: getMessageV2UserDetailQuery,
      variables: messageV2UserDetailVariables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getConfigurationQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getConfigurationQuery,
      variables,
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};

export const writeConfigurationQueryToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getConfigurationQuery,
      variables,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const getChildrenYearGroupGradeFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getChildrenYearGroupGradeQuery,
      variables,
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};
